import { useQuery } from '@tanstack/react-query'

import { getCustomerSubscriptionData, getCustomerSubscriptionInfo } from './useCustomerSubscriptionService'


export const useCustomerSubscriptionDataQuery = (apiParams?: { [k: string]: string; }) => {
  return useQuery({
    queryKey: ['customer-subscription-data', apiParams],
    queryFn: () => getCustomerSubscriptionData(apiParams),
  })
}

export const useCustomerSubscriptionInfoQuery = (establishmentId: string) => {
  return useQuery({
    queryKey: ['customer-subscriptions'],
    queryFn: () => getCustomerSubscriptionInfo(establishmentId),
  })
}
